// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu__2U9gb","menuOpened":"menuOpened__25EQO","menuClosed":"menuClosed__xZAo2","viewSwitchWrapper":"viewSwitchWrapper__RUf-8","viewSwitch":"viewSwitch__2pyK5"};